import { render, staticRenderFns } from "./ClosingOrderCard.vue?vue&type=template&id=58700ed6&"
import script from "./ClosingOrderCard.vue?vue&type=script&lang=js&"
export * from "./ClosingOrderCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports